/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import ServicesLayout from '../../../components/ServicesLayout';
import ConfirmPassword from './ConfirmPassword';

const title = 'Ustawianie hasła';

export default {
  path: '/confirmPassword',

  action() {
    return {
      title,
      component: <ServicesLayout><ConfirmPassword title={title} /></ServicesLayout>,
    };
  },
};



// WEBPACK FOOTER //
// src/routes/login/confirmPassword/index.js